import React from 'react';
import CptCodesGrid from '../../grids/contractGrids/CptCodesGrid';

const CptCodesTab: React.FC = () => {
  return <CptCodesGrid />;
};

export default CptCodesTab;
